module.exports = __webpack_public_path__ + "img/horizontal_4_6_r_5.6c104a36.png";